import { Users } from '@platform/client';
import { OrgRepUser } from '@platform/client/schemas';
import { Icon } from '@platform/components';
import { ReactNode } from 'react';

type NetworkItem = {
  icon: ReactNode;
  header: string;
  description: string;
  link: string;
};

export const NetworkCard = () => {
  const user = Users.useGetCurrentUser();

  const isRepresentative =
    user.isSuccess &&
    (user.data.role === 'representative' || user.data.role === 'representative_with_opportunity');

  const networkItems = [
    {
      icon: (
        <div className='bg-[#1275B1] rounded-[56px] w-6 h-6 flex justify-center items-center'>
          <LinkedInTextSVG />
        </div>
      ),
      header: 'Linkedin Group',
      link: 'https://www.linkedin.com/groups/4964552/',
      description: 'Meet other community members to grow your professional network',
    },
  ];

  if (isRepresentative) {
    networkItems.unshift({
      icon: (
        <div className='w-10 h-10'>
          <Icon type='building-06' size='24' />
        </div>
      ),
      header: 'Corporate connections',
      link: '/dashboard/organization/connect',
      description: 'Get introduced to potential corporate partners or buyers',
    });

    networkItems.unshift({
      icon: (
        <div className='w-10 h-10'>
          <Icon type='users-02' size='24' />
        </div>
      ),
      header: 'Connect with peers',
      link: `https://forms.movingworlds.org/movingworlds/form/PeerConnectionsForm1/formperma/Af9BYrqZIHcBB5tdjqL0yROqkWxe8V4emhaesIsuvRc?userName=${user.data.firstName + ' ' + user.data.lastName}&organizationName=${(user.data as OrgRepUser).organization.name}`,
      description: 'Get introduced to entrepreneurs in your industry or region',
    });
  }

  return (
    <div
      className='p-4 rounded-md border bg-white border-gray-100 w-[253px]'
      data-testid='networkCard'
    >
      <h1>Network</h1>
      {networkItems.map((item) => {
        return (
          <NetworkCardItem
            icon={item.icon}
            header={item.header}
            description={item.description}
            link={item.link}
            key={item.header}
          />
        );
      })}
    </div>
  );
};

const NetworkCardItem = (props: NetworkItem) => {
  const { icon, header, description, link } = { ...props };
  return (
    <div className='rounded-md px-2 py-4 flex flex-row justify-between border bg-gray-50 border-gray-100 gap-2 mt-4'>
      <div className='rounded-[20px] bg-secondary-brand-50 w-10 h-10 p-2'>{icon}</div>
      <div className='flex flex-col gap-1'>
        <a
          className='text-brand-100 font-semibold text-md cursor-pointer hover:underline'
          href={link}
          target='_blank'
        >
          {header}
        </a>
        <div className='text-xs'>{description}</div>
      </div>
    </div>
  );
};
const LinkedInTextSVG = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='11' viewBox='0 0 12 11' fill='none'>
      <path
        d='M3.46392 1.26911C3.46392 1.97002 2.85639 2.53822 2.10696 2.53822C1.35753 2.53822 0.75 1.97002 0.75 1.26911C0.75 0.568201 1.35753 0 2.10696 0C2.85639 0 3.46392 0.568201 3.46392 1.26911Z'
        fill='white'
      />
      <path d='M0.935567 3.47107H3.25515V10.5H0.935567V3.47107Z' fill='white' />
      <path
        d='M6.98969 3.47107H4.6701V10.5H6.98969C6.98969 10.5 6.98969 8.28719 6.98969 6.90364C6.98969 6.07321 7.27324 5.23915 8.40464 5.23915C9.68326 5.23915 9.67556 6.3259 9.6696 7.16782C9.66181 8.26833 9.68041 9.39139 9.68041 10.5H12V6.79029C11.9804 4.42153 11.3631 3.33006 9.33247 3.33006C8.12655 3.33006 7.37903 3.87754 6.98969 4.37287V3.47107Z'
        fill='white'
      />
    </svg>
  );
};
